const initialState = {
    suppliers: [],
};

export const getSuppliersReducer = (state = initialState, action) => {
    switch(action.type) {
        case "GET_SUPPLIERS_SUCCESS":
            return {
                ...state,
                suppliers: action.payload,
            };
        default:
            return state;
    }
};
